// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import React from 'react';
import FilterFilledSvg from "@ant-design/icons-svg/es/asn/FilterFilled";
import AntdIcon from '../components/AntdIcon';

var FilterFilled = function FilterFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FilterFilledSvg
  }));
};

FilterFilled.displayName = 'FilterFilled';
export default React.forwardRef(FilterFilled);